import { render, staticRenderFns } from "./EspeciesTabEcologiaEUso.vue?vue&type=template&id=65c8c340&"
import script from "./EspeciesTabEcologiaEUso.vue?vue&type=script&lang=js&"
export * from "./EspeciesTabEcologiaEUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports